import NumericIncrementInput from './NumericIncrementInput';

export default NumericIncrementInput;
